module.exports = __webpack_public_path__ + "img/icon_3R.67851a63.svg";